import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import styles from './CharityBannerItem.styles.module.scss';
import ParseHTML from 'html-react-parser';

interface CharityBannerItemProps {
  title: string;
  organization: string;
  description: string;
  image: string;
  link: string;
  className: string;
  onClose: () => void;
  isDefault: boolean;
}

const CharityBannerItem: React.FC<CharityBannerItemProps> = ({
  title,
  organization,
  description,
  image,
  link,
  className,
  onClose,
  isDefault,
}) => {
  const divClass = classNames(styles.banner, styles[className] || className);
  const formattedDescription = description?.replace(/\n/g, '<br />');
  
  return (
    <div className={divClass}>
      <CloseOutlined className={styles.closeButton} onClick={onClose} />
      <img src={image} alt={title} className={styles.bannerImage} />
      <h2 className={styles.title} title={title}>
        {title}
      </h2>
      <h3 className={styles.organization} title={organization}>
        {organization}
      </h3>
      <p className={styles.description} title={description}>
        {description && ParseHTML(formattedDescription)}
      </p>
      <a href={link} target="_blank" rel="noopener noreferrer" className={styles.learnMore}>
        {isDefault ? 'ADD BANNER' : 'LEARN MORE'}
      </a>
    </div>
  );
};

export default CharityBannerItem;